import { Row } from '@design-system/components/grid/grid';

type ActionableItemListType<T> = {
  data: Array<T & { id: string }>;
  rowStyle: React.CSSProperties;
  render: (item: T, index: number) => React.ReactNode;
  action: (index: number) => React.ReactNode;
  minimumItems: number;
};

export function ActionableItemList<T>(p: ActionableItemListType<T>) {
  return (
    <>
      {p.data.map((item, i) => (
        <Row key={item.id} style={p.rowStyle}>
          {p.render(item, i)}
          {p.data.length > p.minimumItems && p.action(i)}
        </Row>
      ))}
    </>
  );
}
